import { noSuggest } from "./errors.js";
const args = noSuggest("args");
export class Hkt {
    constructor() { }
}
